export default __webpack_public_path__ + "aa3ef7b82addc7b0e96d0bc690a99521.ogg";